"use client";

import { Box, styled } from "@mui/material";
import {
  Dialog,
  DialogPortal,
  DialogBackdrop,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
  DialogClose,
  Button,
  Tag,
} from "@/ui";
import { SkillLogo } from "@components/shared/SkillLogo";
import SkillSelect from "@components/shared/form/SkillSelect";

const SkillsList = styled(Box)({
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
});

export default function EditSkills({ onClose, open, candidate, onAdd, onRemove }) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogPortal>
        <DialogBackdrop />
        <DialogContent size="lg">
          <DialogHeader>
            <DialogTitle>Edit skills</DialogTitle>
            <DialogClose />
          </DialogHeader>
          <DialogBody>
            <Box>
              Skills help match this candidate to relevant job requirements — add the ones
              that apply, and remove any that don&rsquo;t.
            </Box>
            <Box sx={{ mt: 3, mb: 3 }}>
              <SkillSelect
                exclude={candidate?.skills?.map((skill) => skill.id) || []}
                onChange={onAdd}
                helperText="Choose from our skill library, or type a name that isn't listed to add it as a custom skill."
              />
            </Box>
            {open && (
              <SkillsList>
                {candidate?.skills?.map((skill) => (
                  <Tag
                    key={skill.id}
                    variant="skill"
                    icon={
                      skill.logo && (
                        <SkillLogo
                          sx={{ width: 20, height: 20 }}
                          src={skill.logo}
                          variant="square"
                          title={skill.name}
                          alt={skill.name}
                        />
                      )
                    }
                    removable
                    onRemove={() => onRemove(skill.id)}
                  >
                    {skill.name}
                  </Tag>
                ))}
                {(!candidate?.skills || candidate.skills.length === 0) && (
                  <Box sx={{ mt: 2, mb: 2, fontStyle: "italic" }}>No skills selected</Box>
                )}
              </SkillsList>
            )}
          </DialogBody>
          <DialogFooter>
            <Button variant="secondary" onClick={onClose}>Cancel</Button>
            <Button variant="primary" onClick={onClose}>Done</Button>
          </DialogFooter>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
